import type { ru } from "./ru";

// Перевод сделан машинно. Носителю языка следует вычитать перед launch'ем.
// TODO(translation-review): KZ proofread by native speaker.
export const kk: typeof ru = {
  brand: {
    name: "Orda OS",
    tagline: "Кафенің операциялық жүйесі",
  },
  nav: {
    apps: "Қосымшалар",
    features: "Мүмкіндіктер",
    caseStudy: "Кейс",
    pricing: "Тарифтер",
    faq: "FAQ",
    deck: "Презентация",
    cta: "Кафені қосу",
    ctaShort: "Қосылу",
  },
  rail: {
    ariaLabel: "Секциялар бойынша навигация",
  },
  hero: {
    eyebrow: "Кафенің операциялық жүйесі · Қазақстан",
    nameMeaning: "Orda OS — мекемеңіздің біртұтас штабы: мәзір, асүй, касса, жеткізу және қойма — бәрі бір жерде. Ондаған бағдарламаның орнына бір платформа.",
    serifLine: "мәзір, асүй, касса және қойма — бір организм",
    scrollHint: "Айналдырыңыз — ішке кіріңіз",
    subtitle:
      "Қонақ QR сканерлеп, өзі тапсырыс береді. Асүй тапсырысты лезде көреді. Касса, қойма, аналитика және AI — бір платформада. Орнатусыз, бір күнде іске қосылады.",
    ctaDemo: "Тірі демо",
    ctaContact: "Кафені қосу",
    status: "Кафелерді қабылдаймыз — 1 күнде іске қосу",
    glass: {
      platform: { label: "Платформа", value: "10 қосымша" },
      launch: { label: "Іске қосу", value: "1 күнде дайын" },
      langs: { label: "Тілдер", value: "Қазақша · Русский · English" },
    },
    stats: {
      apps: "қосымша",
      features: "мүмкіндік",
      langs: "тіл",
    },
    ticker: [
      "QR-мәзір",
      "AR-тағамдар 3D",
      "Асүй realtime",
      "Касса және Kaspi QR",
      "AI-көмекші",
      "Қойма және сатып алу",
      "Брондау",
      "Жеткізу",
      "Аналитика",
      "Қазақша · Русский · English",
    ],
  },
  apps: {
    label: "Қосымшалар",
    title: "Бір платформа,",
    accent: "он қосымша",
    aside:
      "Кафедегі әркімге — өз экраны: қонаққа, аспазға, кассирге, даяшыға, иесіне. Бәрі realtime байланысқан: қонақтың тапсырысы асүйге ол телефонын қойғанша жетеді.",
    dragHint: "айналдыру үшін тартыңыз",
    openDemo: "Демоны ашу",
    downloadCashier: "Windows кассасын жүктеу",
    totalNote:
      "Бұл бәрі емес: сатып алушы, қабылдаушы, қоймашы және курьер — платформада барлығы {total} қосымша.",
    items: {
      guest: {
        name: "Қонақ мәзірі",
        role: "сканерлейді, таңдайды, тапсырыс береді",
        desc:
          "Үстелдегі QR фотолы мәзірді, AR-дағы 3D-тағамдарды және AI-кеңесшіні ашады. Үстелге ортақ себет, телефоннан төлеу — даяшыны күтудің қажеті жоқ.",
        tags: ["QR", "AR / 3D", "AI-кеңесші", "Ортақ себет"],
      },
      kitchen: {
        name: "Асүй",
        role: "тапсырысты лезде көреді",
        desc:
          "Аспаз экраны: жаңа тапсырыстар realtime келеді, бір тап — «дайындалуда», екіншісі — «дайын». Даяшы бірден хабарлама алады.",
        tags: ["KDS", "Realtime", "Тағам статусы"],
      },
      cashier: {
        name: "Касса",
        role: "ауысым, төлемдер, чектер",
        desc:
          "Ауысымы, жеңілдігі және сплит-төлемі бар веб-касса. Kaspi QR, қолма-қол, карта — үстелді үш түртумен жабу.",
        tags: ["Kaspi QR", "Сплит-төлем", "Ауысымдар"],
      },
      waiter: {
        name: "Даяшы",
        role: "үстелдер қалтада",
        desc:
          "Даяшы телефонындағы PWA: өз үстелдері, қонақ шақырулары, тапсырыстар мен асүй статустары. Тағам дайын болғанда — push-хабарлама.",
        tags: ["PWA", "Push", "Қонақ шақыруы"],
      },
      admin: {
        name: "Әкімші панелі",
        role: "сезім емес — сандар",
        desc:
          "Мәзір, бағалар, стоп-лист, қызметкерлер, пікірлер және аналитика: түсім, топ тағамдар, орташа чек, қонақ воронкасы — бір экранда.",
        tags: ["Аналитика", "Мәзір", "Қызметкерлер"],
      },
      booking: {
        name: "Брондау",
        role: "үстел алдын ала",
        desc:
          "Қонақ Kaspi арқылы алдын ала төлеммен үстел брондайды — жалған брондар жоғалады. Зал картасы: кабиналар, караоке, бильярд.",
        tags: ["Алдын ала төлем", "Зал картасы"],
      },
    },
  },
  features: {
    label: "Мүмкіндіктер",
    title: "Платформа",
    accent: "не істей алады",
    aside:
      "Өнімде қазірдің өзінде 140+ мүмкіндік бар. Мұнда — кафелер Orda OS-қа ауысатын сегізі.",
    list: [
      {
        title: "QR-мәзір және AR",
        sub: "қонақ тәжірибесі",
        body:
          "Үш тілдегі фотолы мәзір қосымшасыз бір секундта ашылады. Флагман тағамдарда — 3D-модель: қонақ камераны бағыттап, виртуалды табақты өз үстеліне қояды. Мұндай мәзір өзі сатады.",
        tags: ["3 тіл", "AR", "Қосымшасыз"],
      },
      {
        title: "Realtime-асүй",
        sub: "жоғалған тапсырыс — нөл",
        body:
          "Қонақтың тапсырысы асүй экранында лезде пайда болады — қағазсыз, айқайсыз. Race-safe архитектура: екі аспаз бір тағамды екі рет алмайды, статустар кез келген интернетте сәйкеседі.",
        tags: ["KDS", "Realtime"],
      },
      {
        title: "Касса және төлемдер",
        sub: "Kaspi QR · сплит · ауысымдар",
        body:
          "Қонақ өз телефонынан Kaspi QR арқылы төлейді, компания шотты бәріне бөледі. Кассир ауысымды, жеңілдіктерді, рефандтарды көреді. Чектер ESC/POS принтерге басылады.",
        tags: ["Kaspi QR", "Сплит-төлем"],
      },
      {
        title: "Қойма және сатып алу",
        sub: "сатып алушы → қабылдаушы → қоймашы",
        body:
          "Базардан чек фотосымен сатып алу, айырмашылықтарды тіркейтін қабылдау, қалдықтар мен есептен шығару. Үш рөл — үш бөлек қосымша, иесі бүкіл тізбекті көреді.",
        tags: ["Чек фотосы", "Айырмашылықтар"],
      },
      {
        title: "AI-көмекшілер",
        sub: "қонаққа, аспазға, иесіне",
        body:
          "Қонаққа AI «екеуге 5000 ₸» бюджетіне кешкі ас құрастырады. Аспазға ауысым бойынша кеңес береді. Иесіне «жұма күні қанша таптық?» сұрағына қазақша және орысша жауап береді.",
        tags: ["GPT", "KZ / RU / EN"],
      },
      {
        title: "Telegram-алерттер",
        sub: "кафе иесінің қалтасында",
        body:
          "Жаңа тапсырыс, төлемсіз кеткен қонақ, қабылдаудағы айырмашылық, күндік есеп — иесі бәрін оқиға сәтінде Telegram-нан алады. Әкімші панелін ашпай-ақ.",
        tags: ["Owner-алерттер", "Күн есебі"],
      },
      {
        title: "Лоялдылық және пікірлер",
        sub: "қонақ қайтып келеді",
        body:
          "Келгені үшін ұпайлар, тұрақты қонақтарды тану, төлемнен кейін фотолы пікірлер және бақыт дөңгелегі. Қайтып келген қонақ — ең арзан маркетинг.",
        tags: ["Ұпайлар", "Бақыт дөңгелегі"],
      },
      {
        title: "Жеткізу және курьер",
        sub: "залдан тыс",
        body:
          "Қонақ сол витринадан үйге тапсырыс береді, курьер өз қосымшасында статус трекингімен және SOS-түймесімен тапсырысты жүргізеді.",
        tags: ["Жеткізу", "Трекинг"],
      },
    ],
  },
  process: {
    label: "Іске қосу",
    title: "Іске қосу —",
    accent: "бір күн",
    aside:
      "Кафені қосу жөндеу жұмысындай сезілмеуі керек. Міне, бүкіл жол — қоңыраудан QR арқылы алғашқы тапсырыстарға дейін.",
    steps: [
      {
        when: "1-күн · таң",
        title: "Кафені құрамыз",
        body:
          "Тенант ашамыз, мәзірді жүктейміз (қағаз мәзірдің фотосынан да болады), бағалар, тағам фотолары мен үстелдер. Бәрін біз істейміз — сізден тек мәзір.",
      },
      {
        when: "1-күн · күндіз",
        title: "Үстелдерге QR",
        body:
          "Әр үстелге QR-код басамыз. Токен әр төлемнен кейін ауысады — қолдан жасау немесе сілтемені сақтап қалу мүмкін емес.",
      },
      {
        when: "1-күн · кеш",
        title: "Команданы үйретеміз",
        body:
          "Даяшылар мен асүймен 30 минут. PIN арқылы кіру, парольсіз, 40 беттік нұсқаулықсыз. Кешке қонақтар өздері тапсырыс беріп отырады.",
      },
      {
        when: "Әрі қарай",
        title: "Қолдап жүреміз",
        body:
          "Telegram-дағы алерттер, үзіліссіз жаңартулар, қазақша және орысша қолдау. Платформа өседі — сіз ештеңе қайта орнатпайсыз.",
      },
    ],
    footnote:
      "Жабдық сатып алудың қажеті жоқ: қызметкерлердің телефондары мен асүйге кез келген планшет жеткілікті.",
  },
  caseAlem: {
    label: "Кейс",
    title: "Нағыз кафеде",
    accent: "жұмыс істеп тұр",
    quote:
      "Платформадағы алғашқы кафе: үстелдерде QR-мәзір, планшетте асүй, касса мен қойма — бәрі тірі, демо-стенд емес.",
    location: "Платформаның алғашқы клиенті · 2026 мамырынан live",
    liveBadge: "Тірі кафе",
    stats: {
      dishes: "мәзірдегі тағам",
      tables: "QR-лы үстел",
      staff: "қызметкер",
      ar: "AR-дағы тағам",
    },
    cta: "Әлем мәзірін ашу",
    ctaNote: "Бұл нағыз витрина — дәл осы мәзірді кафе үстеліндегі қонақтар көреді.",
  },
  pricing: {
    label: "Тарифтер",
    title: "Адал",
    accent: "бағалар",
    subtitle:
      "Ұзақ мерзімді келісімшартсыз — кез келген айда бас тартуға болады. Іске қосу жеңілдік бағалары, теңгемен.",
    popular: "Танымал",
    perMonth: "/ай",
    promo: "Іске қосу",
    contactUs: "Талқылау",
    freeTrial: "15 күн тегін",
    validUntil: "Жеңілдік бағалары тек 2026 жылдың соңына дейін",
    starter: {
      name: "Starter",
      price: "10 000 ₸",
      oldPrice: "16 000 ₸",
      currency: "",
      features: [
        "10 үстелге дейін",
        "Қонақтарға QR-мәзір",
        "Бір әкімші",
        "Базалық аналитика",
        "Email-қолдау",
      ],
      cta: "Қосылу",
    },
    delivery: {
      name: "Жеткізу",
      price: "15 000 ₸",
      oldPrice: "23 000 ₸",
      currency: "",
      features: [
        "Жеткізуге арналған витрина",
        "Сол мәзірден үйге тапсырыс",
        "Трекингі бар курьер қосымшасы",
        "Асүй (KDS)",
        "Касса + Kaspi QR",
        "Чат-қолдау",
      ],
      cta: "Қосылу",
    },
    pro: {
      name: "Pro",
      price: "25 000 ₸",
      oldPrice: "39 000 ₸",
      currency: "",
      features: [
        "50 үстелге дейін",
        "Starter-дің бәрі",
        "Даяшы PWA",
        "Асүй (KDS)",
        "Касса + Kaspi QR",
        "AI-көмекші",
        "Үстел брондау",
        "Чат-қолдау",
      ],
      cta: "Қосылу",
    },
    enterprise: {
      name: "Enterprise",
      price: "40 000 ₸",
      oldPrice: "62 000 ₸",
      currency: "",
      features: [
        "Үстелдер шексіз",
        "Multi-branch (желі)",
        "Кастом-интеграциялар",
        "Кафеге брендтеу",
        "SLA + басым қолдау",
        "Жеке менеджер",
      ],
      cta: "Талқылау",
    },
    network: {
      name: "Желі",
      price: "Сұраныс бойынша",
      oldPrice: "",
      currency: "",
      features: [
        "Бір панельде бірнеше мекеме",
        "Желі бойынша түсім жиынтығы",
        "Барлық нүктелерге white-label",
        "Әр нүкте үшін айлық төлем",
        "Кастом-интеграция және онбординг",
        "Жеке менеджер",
      ],
      cta: "Хабарласу",
    },
  },
  builder: {
    label: "Конструктор",
    title: "Тарифті",
    accent: "өзіңіз құрастырыңыз",
    subtitle:
      "Байланыс операторларындағыдай: 2 000 ₸ база — әрі қарай жүгірткілерді жылжытыңыз. Тек нақты қолданатыныңызға төлейсіз.",
    presets: "Дайын жинақтар",
    presetTakeaway: "Залсыз нүкте",
    presetCafe: "Залы бар кафе",
    presetResto: "Мейрамхана",
    presetMax: "Бәрі қосылған",
    base: "Платформа базасы",
    baseHint: "QR-мәзір-витрина, касса (веб + Windows), әкімші панелі, қалдық есебі, өзімен әкету",
    hall: "Зал және үстелдер",
    hallHint: "Үстелдердегі QR, қонақ телефонынан тапсырыс, даяшы қосымшасы",
    hallOptions: ["Залсыз", "10 үстелге дейін", "30 үстелге дейін", "50 үстелге дейін", "Шексіз"],
    staff: "Қызметкерлер",
    staffHint: "Персонал аккаунттары: кассирлер, даяшылар, аспаздар…",
    staffOptions: ["5-ке дейін", "10-ға дейін", "20-ға дейін", "Шексіз"],
    modules: "Модульдер",
    mDelivery: "Жеткізу",
    mDeliveryHint: "Жеткізу витринасы, тірі картадағы курьерлер, қонақпен чат",
    mAi: "AI-көмекші",
    mAiHint: "Қонақ пен персоналға арналған чат-көмекші",
    mWl: "Өз брендіңіз",
    mWlHint: "Orda OS орнына кафе логотипі мен атауы (white label)",
    included: "Кез келген жинаққа кіреді",
    includedList: ["Ас үй (KDS)", "Брондау", "Адалдық", "Қойма және сатып алу", "Бухгалтер кабинеті", "Аналитика", "Мәзірдің 6 тілі", "Kaspi QR"],
    total: "Сіздің тариф",
    perMonth: "/ай",
    matches: "= тариф",
    free: "қосулы",
    cta: "Есеп алу",
    ctaHint: "Конфигурация өтініммен бірге менеджерге кетеді — қоңырау шалып, бағаны растап, қосамыз.",
  },
  faq: {
    label: "FAQ",
    title: "Жиі қойылатын",
    accent: "сұрақтар",
    items: [
      {
        q: "Енгізуге қанша уақыт кетеді?",
        a: "1 күн. Біз тенантыңызды құрамыз, мәзірді жүктейміз (фотодан да болады), үстелдерге QR-кодтар басамыз, қызметкерлерді 30 минутта үйретеміз. Бірінші кеште-ақ қонақтар QR арқылы тапсырыс бере бастайды.",
      },
      {
        q: "Кафемнің деректері қайда сақталады?",
        a: "Деректер Supabase-те (PostgreSQL + RLS isolation). Әр кафе оқшауланған — сіздің аспазыңыз тек сіздің тапсырыстарыңызды көреді. Сұраныс бойынша — барлық деректерді CSV-ге шығару.",
      },
      {
        q: "4 үстелі бар кішкентай кафеге жарай ма?",
        a: "Иә. Ең кіші Starter тарифі 10 үстелге дейін жабады. Кішкентай кафелер көбіне ең үлкен пайда көреді — даяшы біреу, ал QR-мәзір оның жұмысының жартысын алып тастайды.",
      },
      {
        q: "Касса (Қазақстандағы онлайн-касса) керек пе?",
        a: "Orda OS — тапсырыстарды басқару және Kaspi QR арқылы төлем. Фискализация (онлайн-касса) — бөлек интеграция, Salyk/онлайн-касса қолдансаңыз сіз үшін қосамыз.",
      },
      {
        q: "Интернет өшіп қалса ше?",
        a: "Платформаға кәдімгі интернет жеткілікті — тіпті мобильді байланыс жарайды. Деректер бұлтта, ешнәрсе жоғалмайды әрі кез келген құрылғыдан қолжетімді. Байланысы тұрақсыз орындарға форматыңызға сай шешім таңдаймыз.",
      },
    ],
  },
  lead: {
    label: "Өтінім",
    title: "Кафеңіз бар ма?",
    subtitle:
      "Нөміріңізді қалдырыңыз — бір сағат ішінде қоңырау шалып, платформаны сіздің мәзіріңізде көрсетіп, форматыңызға тариф есептеймін.",
    nameLabel: "Атыңыз",
    namePlaceholder: "Алмас",
    phoneLabel: "Телефон",
    cafeLabel: "Кафе атауы",
    cafePlaceholder: "Café Әлем",
    cityLabel: "Қала",
    noteLabel: "Хабарлама",
    notePlaceholder: "Қанша үстел, не маңызды, қандай интеграциялар керек...",
    submit: "Ұсыныс алу",
    submitting: "Жіберілуде...",
    privacy:
      "«Жіберу» батырмасын басу арқылы кері байланыс үшін деректерді өңдеуге келісесіз. Ешқандай спам жоқ.",
    successTitle: "Рақмет!",
    successBody:
      "Өтініміңіз қабылданды. Бір сағат ішінде қоңырау шаламыз — танысуға қуаныштымыз 🤝",
    configAttached: "Конструктордан жиналған конфигурация өтінімге тіркелді",
    errors: {
      name_too_short: "Аты тым қысқа (кемінде 2 таңба).",
      name_too_long: "Аты тым ұзын (ең көбі 80 таңба).",
      phone_invalid: "Телефон дұрыс емес сияқты. Кемінде 8 цифр.",
      note_too_long: "Хабарлама тым ұзын (ең көбі 1000 таңба).",
      rate_limited: "Бұл IP-ден өтінімдер тым көп. Бір сағаттан кейін көріңіз немесе Telegram-ға жазыңыз.",
      DB_ERROR: "Өтінімді сақтау мүмкін болмады. Қайталап көріңіз немесе Telegram-ға жазыңыз.",
      INVALID_JSON: "Деректерді жіберу қатесі. Бетті жаңартыңыз.",
      unknown: "Бірдеңе дұрыс болмады. Қайталап көріңіз немесе Telegram-ға жазыңыз.",
    },
  },
  contact: {
    title: "Байланысу",
    subtitle: "Жазыңыз — бір сағат ішінде жауап беремін.",
    whatsapp: "WhatsApp",
    telegram: "Telegram",
    instagram: "Instagram",
    email: "Email",
    message: "Сәлеметсіз бе! Кафеме Orda OS қызықтырады.",
  },
  waiter: {
    eyebrow: "Қонақ · цифрлық көмекші",
    title: "Сіздің цифрлық",
    accent: "даяшыңыз",
    body:
      "Интерактивті 3D-көмекші қонақты қарсы алады, бюджет пен көңіл-күйге қарай тағам ұсынады және тапсырысқа жетелейді — үш тілде, кезексіз және күтусіз.",
    chips: ["Курсорды бақылайды", "Нақты уақыттағы 3D", "AI-кеңесші"],
    cta: "Тірі демо",
    hint: "Курсорды қозғаңыз — ол сізді бақылайды",
  },
  band: {
    eyebrow: "Orda OS",
    line: "Мәзір, асүй, касса және қойма — бір организм.",
    sub: "Он сервистің орнына бір платформа. Бір күнде іске қосу.",
    cta: "Кафені қосу",
  },
  footer: {
    copyright: "© 2026 Orda OS · e-menu.bar",
    tagline: "Қазақстанда жасалған 🇰🇿",
    privacy: "Құпиялылық",
    terms: "Шарттар",
    download: "Windows кассасы",
  },
  legal: {
    back: "← Басты бетке",
  },
};
